import { Controller } from "@hotwired/stimulus"

// Plays a short TTS sample of a candidate voice via the assistant speak
// endpoint (?voice=<key>). Degrades quietly: if the endpoint has no key /
// errors, the button just resets with no sample.
export default class extends Controller {
    static values = { url: String }

    preview(event) {
        const key = event.params.key
        if (!key) return
        const button = event.currentTarget

        if (this.audio) {
            this.audio.pause()
            this.audio = null
        }
        button.disabled = true
        this.audio = new Audio(`${this.urlValue}?voice=${encodeURIComponent(key)}`)
        this.audio.addEventListener("ended", () => { button.disabled = false })
        this.audio.addEventListener("error", () => { button.disabled = false })
        this.audio.play().catch(() => { button.disabled = false })
    }
}
